"use strict";

import objectPath from "object-path";

const formatAddress = (address={}) => {
    const newAddress = {
        company_name: objectPath.coalesce(address, ['company_name','s_company','company'], ''),
        f_name: objectPath.coalesce(address, ['f_name','s_f_name',], ''),
        l_name: objectPath.coalesce(address, ['l_name','s_l_name',], ''),
        attention: objectPath.coalesce(address, ['attention','s_attention',], ''),
        address: objectPath.coalesce(address, ['address','b_address','s_address',], ''),
        address2: objectPath.coalesce(address, ['address2','b_address2','s_address2',], ''),
        city: objectPath.coalesce(address, ['city', 'b_city', 's_city',], ''),
        state: objectPath.coalesce(address, ['state', 'b_state', 's_state',], ''),
        zip5: objectPath.coalesce(address, ['zip5', 'b_zip5', 's_zip5',], ''),
        zip4: objectPath.coalesce(address, ['zip4', 'b_zip4', 's_zip4',], ''),
        phone: objectPath.coalesce(address, ['phone', 'b_phone', 's_phone',], ''),
        phone_ext: objectPath.coalesce(address, ['phone_ext', 'b_phone_ext', 's_phone_ext',], ''),
        fax: objectPath.coalesce(address, ['fax', 'b_fax', 's_fax',], ''),
        location_class: objectPath.coalesce(address, ['location_class', 'b_location_class', 's_location_class',], ''),
    };
    newAddress.attention = !newAddress.attention ? `${newAddress.f_name} ${newAddress.l_name}` : newAddress.attention;
    return newAddress;
};

export default formatAddress;